import { API_GET_PROFFIT_SEARCH_GROUP_SUCCESS } from '../actions/ProffitSearchGroupAction';
const INITIAL_STATE = {
    group: null,
};
// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, { payload, type }) => {
    switch (type) {
        case API_GET_PROFFIT_SEARCH_GROUP_SUCCESS: {
            return Object.assign(Object.assign({}, state), { group: payload });
        }
        default: {
            return state;
        }
    }
};
